// extracted by mini-css-extract-plugin
export default {"project_container":"style_project_container__RDny7","title_container":"style_title_container__Mwkb7"};